export default {
      id: "check-usage",
      viewBox: "0 0 78.369 78.369",
      url: "/dist/svg/" + "sprite.svg#check-usage",
      toString: function () {
        return this.url;
      }
    }